import type {z} from "zod";

import {AddServiceNoteBody} from "@project/sdk/engineering/zod";
import {z as zod} from "zod";
import {requiredStringSchema} from "../../../../../../../shared/validation/required-string.schema";
import {noteFieldLabelIds} from "../../../../../../../support/messages/note.messages";

export const addServiceNoteFormSchema = zod.object({
  title: requiredStringSchema(AddServiceNoteBody.shape.title, noteFieldLabelIds.title),
  content: requiredStringSchema(AddServiceNoteBody.shape.content, noteFieldLabelIds.content),
});
export type AddServiceNoteFormPayload = z.output<typeof addServiceNoteFormSchema>;

export const draftAddServiceNoteFormSchema = addServiceNoteFormSchema.partial();
export type DraftAddServiceNoteFormPayload = z.output<typeof draftAddServiceNoteFormSchema>;
